/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';

export interface FortifyButtonTextProps {
  href?: string;
  class?: string;
  variant?: 'default' | 'secondary';
  onClick?: (event: MouseEvent) => void;
}

export const FortifyButtonText: FunctionalComponent<FortifyButtonTextProps> = (props, children) => {
  const {
    href,
    class: classProp,
    variant = 'secondary',
    onClick,
  } = props;

  const isLink = !!href;
  const TagType = isLink ? 'a' : 'button';

  return (
    <TagType
      type={!isLink && 'button'}
      href={isLink && href}
      target={isLink && '_blank'}
      rel={isLink && 'noreferrer noopener'}
      onClick={onClick}
      class={{
        button_text: true,
        't-b3': true,
        'c-gray-9': variant === 'default',
        'c-secondary': variant === 'secondary',
        [`button_text_${variant}`]: true,
        [classProp]: Boolean(classProp),
      }}
    >
      {children}
    </TagType>
  );
};
